import {
  METRIX_START,
  METRIX_END,
  METRIX_DATA,
  METRIX_BY_ID,
  TYPE_CONFIG_DATA,
  TYPE_CONFIG_DATA_ID,
  RESET_COMMITMENT,
  METRICS_CALCULATION,
  CCCM_CALC_ANALYSIS_RESULTS_SUCCESS,
  CCPC_CALC_ANALYSIS_RESULTS_SUCCESS,
} from '../../actions/ContractCompilance/ActionTypes';
const initialState = {
  metrixLoading: false,
  metrixData: [],
  metrixDataById: {},
  typeConfigData: [],
  typeConfigDataById: {},
  metricsCalculation: [],
  cccmCalcAnalysisResults: [],
  ccpcCalcAnalysisResults: [],
};

const ContractCompilanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case METRIX_DATA:
      return {
        ...state,
        metrixData: action.data,
      };
    case METRIX_BY_ID:
      return {
        ...state,
        metrixDataById: action.data,
      };
    case TYPE_CONFIG_DATA:
      return {
        ...state,
        typeConfigData: action.data,
      };
    case TYPE_CONFIG_DATA_ID:
      return {
        ...state,
        typeConfigDataById: action.data,
      };
    case METRIX_START:
      return {
        ...state,
        metrixLoading: true,
      };
    case METRIX_END:
      return {
        ...state,
        metrixLoading: false,
      };
    case METRICS_CALCULATION:
      return {
        ...state,
        metricsCalculation: action.data,
      };
    case CCCM_CALC_ANALYSIS_RESULTS_SUCCESS:
      return {
        ...state,
        cccmCalcAnalysisResults: action.data,
      };
    case CCPC_CALC_ANALYSIS_RESULTS_SUCCESS:
      return {
        ...state,
        ccpcCalcAnalysisResults: action.data,
      };
    case RESET_COMMITMENT:
      return initialState;// for resetting all the variables
    default:
      return state;
  }
};

export default ContractCompilanceReducer;
